import React from 'react'
import { Layout } from 'antd';
const { Footer } = Layout;

const FooterBar = () => {
  return (
    <div>
        <Footer
          style={{
            textAlign: 'center',
          }}
        >
          BTA ©2022 All Rights Reserved
        </Footer>
    </div>
  )
}

export default FooterBar